import React, { useEffect } from 'react';
import { useObservable } from 'react-use-observable';

import TopPage from 'v2/components/Shared/TopPage';
import eduzzAccountsService from 'v2/services/eduzzAccount';
import { partnerCommissionsService } from 'v2/services/reports/partnerCommissions';

import { Details } from './Details';
import { Filter } from './Filter';
import { Table } from './Table';

export const Refunds = () => {
  const [isLoadingAccount] = useObservable(() => eduzzAccountsService.getLoadingAccount(), []);
  const [user] = useObservable(() => eduzzAccountsService.getUser(), []);

  useEffect(() => {
    return () => partnerCommissionsService.cleanFilter();
  }, []);

  if (isLoadingAccount || !user) return null;

  return (
    <>
      <TopPage title='Reembolsos' extra='Acompanhe e gerencie os reembolsos das suas vendas.' disableAlerts />

      <Filter />
      <Details />
      <Table />
    </>
  );
};
